import { render } from "./DataConcentratorEdit.vue?vue&type=template&id=2f59dd87"
import script from "./DataConcentratorEdit.vue?vue&type=script&lang=js"
export * from "./DataConcentratorEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__